import React from 'react';

const Rating = ({ rating, outOf = 5 }) => {
  const filledStars = '★'.repeat(rating);
  const unfilledStars = '☆'.repeat(outOf - rating);

  return (
    <div className='rating'>
      {filledStars}
      {unfilledStars}
    </div>
  );
};

export default Rating;
